import { Table, TableBody } from "@mui/material";
import { CurrencyRupee as CommercialIcon } from "@mui/icons-material";
import type { VendorProfileFacility, VendorType } from "../types";
import { SectionCard } from "../components/SectionCard";
import { FieldRow } from "../components/FieldRow";
import { formatText } from "../utils/format";
import { deriveCommercial } from "@/pages/VendorOnboarding/reviewer/commercialTerms";

type Props = {
  profile: VendorProfileFacility;
  vendorType: VendorType;
};

export function CommercialTermsSection({ profile, vendorType }: Props) {
  const showAdvance = vendorType !== "International";
  const derived = deriveCommercial(
    profile.first_tranche_payment_basis ?? undefined,
    profile.payment_terms_pattern ?? undefined,
    profile.credit_days != null ? String(profile.credit_days) : undefined,
  );

  return (
    <SectionCard icon={<CommercialIcon fontSize="small" />} title="Commercial Terms">
      <Table size="small">
        <TableBody>
          <FieldRow
            label="Credit Days"
            value={
              profile.credit_days != null ? String(profile.credit_days) : "—"
            }
          />
          <FieldRow
            label="Payment Terms Pattern"
            value={formatText(profile.payment_terms_pattern)}
          />
          <FieldRow
            label="First Tranche Payment Basis"
            value={formatText(profile.first_tranche_payment_basis)}
          />
          {showAdvance && (
            <>
              <FieldRow label="Advance Applicable" value={derived.advanceApplicable} />
              <FieldRow label="Advance Percentage" value={derived.advancePercent} />
            </>
          )}
          <FieldRow label="Payment Terms Remarks" value={derived.remarks} />
        </TableBody>
      </Table>
    </SectionCard>
  );
}

export default CommercialTermsSection;
